import { FC, ReactNode } from 'react';

import * as Styles from './styles';

interface IKey {
  icon: string | ReactNode;
}

const Key: FC<IKey> = ({ icon }) => {
  return (
    <Styles.Key>
      <kbd>{icon}</kbd>
    </Styles.Key>
  );
};

export function ModalHelp() {
  return (
    <Styles.Container>
      <Key icon="esc" />
      <Key icon={<i>chevron_left</i>} />
      <Key icon={<i>chevron_right</i>} />
    </Styles.Container>
  );
}
